import * as Cesium from "cesium";
import { useEffect } from "react";

import { masterplanVm } from "../../../data/c4/masterplan.data";
// import modelings from "../../../data/modelings.data";
import useSelectedMenuStore from "../stores/useSelectedMenuStore";
import useViewerStore from "../stores/useViewerStore";
import useYellowEdgeStore from "../stores/useYellowEdgeStore";

export default function useSelectModels() {
  const { viewer } = useViewerStore();

  const nameOverlay: HTMLElement = document.createElement("div");
  if (viewer) {
    viewer.container.appendChild(nameOverlay);
  }
  nameOverlay.className = "backdrop";
  nameOverlay.style.display = "none";
  nameOverlay.style.position = "absolute";
  nameOverlay.style.bottom = "0";
  nameOverlay.style.left = "0";
  nameOverlay.style.pointerEvents = "none";
  nameOverlay.style.padding = "4px";
  nameOverlay.style.backgroundColor = "black";

  function createPickedFeatureDescription(data: {
    name: string;
    info: { name: string };
  }) {
    const description = `
        <div>
          <h2>${data ? data.name : ""}_${data ? data.info.name : ""}</h2>
   
          
        </div>
      `;

    return `
        <header>
          <style>
            .content-box {
              width: 240px;
              padding: 10px;
              font-size: 10px;
              box-sizing: border-box;
              border-radius: 10px;
              color: white;
              background: rgba(0, 0, 0, 0.75);
              right: 0;
              position: absolute;
            }
          </style>
        </header>
        <div class="container">
          <div class="content-box">
           ${description}
          </div>
        </div>
      `;
  }

  // const [, setClickedFeature] = useState<null | unknown>(null);

  const { selectFeature } = useYellowEdgeStore();

  const { selectedMenu } = useSelectedMenuStore();

  const { setPhase } = useViewerStore();

  useEffect(() => {
    if (!viewer) return;

    if (selectedMenu !== "KSS") {
      viewer.selectedEntity = undefined;
    }
  }, [selectedMenu, viewer]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (!viewer) return;

    const selected = {
      feature: undefined,
      originalColor: new Cesium.Color(),
      name: null,
    };

    const clickHandler = viewer.screenSpaceEventHandler.getInputAction(
      Cesium.ScreenSpaceEventType.LEFT_CLICK,
    );

    // 클릭 이벤트 핸들러 추가
    viewer.screenSpaceEventHandler.setInputAction(
      (movement: Cesium.ScreenSpaceEventHandler.PositionedEvent) => {
        if (selectedMenu !== "KSS") return;
        // 이전에 선택된 피처의 색상을 원래대로 돌립니다.
        if (Cesium.defined(selected.feature)) {
          // console.log("selected.feature", selected.feature);
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (selected.feature as any).color = selected.originalColor;
          selected.feature = undefined;
          selectFeature();
        }

        // 새로운 피처를 선택합니다.
        const pickedFeature = viewer.scene.pick(movement.position);

        if (Cesium.defined(pickedFeature)) {
          try {
            // eslint-disable-next-line no-underscore-dangle
            // setClickedFeature(pickedFeature._content._tile._tileset._url);

            selected.feature = pickedFeature;

            // pickedFeature.color = Cesium.Color.YELLOW; // 하이라이트 색상

            Cesium.Color.clone(pickedFeature.color, selected.originalColor);

            selectFeature(pickedFeature);
            // sYellow.selected = [pickedFeature];

            try {
              viewer.selectedEntity = pickedFeature;

              // eslint-disable-next-line no-underscore-dangle
              const url = pickedFeature._content._tile._tileset._url;

              masterplanVm.items.forEach((item) => {
                if (item.modelPath === url) {
                  if (viewer.selectedEntity) {
                    viewer.selectedEntity.description =
                      new Cesium.ConstantProperty(
                        createPickedFeatureDescription({
                          name: item.name,
                          info: { name: item.info?.name || "" },
                        }),
                      );
                  }

                  if (item.phase) {
                    setPhase(item.phase);
                  }
                }
              });

              // eslint-disable-next-line @typescript-eslint/no-unused-vars
            } catch (e) {
              console.log(e);
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              if (clickHandler) clickHandler(movement as any);
            }
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
          } catch (e) {
            console.log(e);
            // eslint-disable-next-line no-useless-return
            return;
          }
        } else {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-lonely-if
          if (clickHandler) clickHandler(movement as any); // 타입 캐스팅을 any로 변경
        }
      },
      Cesium.ScreenSpaceEventType.LEFT_CLICK,
    );

    // 필요한 경우 정리 함수 추가
    // eslint-disable-next-line consistent-return
    return () => {
      viewer.screenSpaceEventHandler.removeInputAction(
        Cesium.ScreenSpaceEventType.LEFT_CLICK,
      );
    };
  }, [selectFeature, selectedMenu, setPhase, viewer]); // 의존성 배열에 clickedFeature 추가
}
